<template>
  <div class="content-box">
    <p class="little-title">{{ $t('Policy') }}</p>
    <p class="list">{{ $t('PolicyDescribe') }}</p>
    <p>{{ $t('updateData') }}</p>

    <p class="little-title">{{ $t('acceptPolicy') }}</p>
    <p class="list">{{ $t('acceptPolicyDes') }}</p>
    <p>{{ $t('acceptPolicyDescribe') }}</p>

    <p class="little-title">{{ $t('infoCollect') }}</p>
    <p class="list">{{ $t('infoCollectDes') }}</p>
    <p class="list">{{ $t('infoCollectDescribe') }}</p>
    <p>{{ $t('infoCollectDetail') }}</p>

    <p class="little-title">{{ $t('safety') }}</p>
    <p>{{ $t('safetyDescribe') }}</p>

    <p class="little-title">{{ $t('personal') }}</p>
    <p class="list">{{ $t('personalDescribe') }}</p>
    <p>{{ $t('email') }}iplexservice@gmail.com</p>
  </div>
</template>

<script>
  import locales from './lang'

  export default {
    name: 'privacy-terms-component',
    locales
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
  }

  .content-box {
    max-width: 1180px;
    margin: 1.6rem auto 1.8rem;
  }

  p {
    font-size: .16rem;
    color: #111;
    letter-spacing: 0;
    line-height: .22rem;
  }

  .little-title {
    font-size: .32rem;
    font-weight: 600;
    color: #333;
    letter-spacing: 0;
    margin-bottom: .24rem;
    margin-top: .64rem;
    line-height: .48rem;
    &:first-child {
      margin-top: 0;
      color: #111;
      font-size: .4rem;
      line-height: .4rem;
    }
  }

  .list {
    margin-bottom: .24rem;
  }
  
  @media (max-width: 1228px) {
    .content-box {
      padding: 0 24px;
    }
  }
  @media (max-width: 991px) {
    .content-box {
      margin: .24rem auto .8rem;
    }
    .little-title {
      font-size: 20px;
      color: #111111;
      line-height: 28px;
      margin-bottom: .08rem;
      margin-top: .24rem;
      &:first-child {
        margin-top: 0;
        font-size: 24px;
        line-height: 32px;
      }
    }
    p {
      font-size: 14px;
      color: #666666;
      line-height: 20px;
    }
    .list {
      margin-bottom: .16rem;
    }
  }
</style>



// WEBPACK FOOTER //
// PrivacyTerms.vue?27209c45